'use client';

import { c as _c } from "react/compiler-runtime";
import { faComment } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@uzh-bf/design-system';
import { useTranslations } from 'next-intl';
import { useParams, usePathname, useSearchParams } from 'next/navigation';
import { Suspense } from 'react';
import { useCachedUnitProgressSWR } from '~/app/actions/progress';
import BookmarkAction from '~/components/interaction/BookmarkAction';
import StickyNavBar from '~/components/StickyNavBar';
import { CourseUnit } from '~/payload-types';
import BlockContent from './BlockContent';
import { CompletionTagSkeleton } from './BlockSkeleton';
import BlockTag from './BlockTag';
import CompletionTag from './CompletionTag';
interface BlockProps {
  block: CourseUnit['components'][0];
  timeUnit: number;
  unitTitle?: string;
  courseId: string | number;
  moduleId: string | number;
  unitId: string | number;
  unitIndex?: number;
  nextUrl?: string;
  prevUrl?: string;
  continueDisabled?: boolean;
  repositoryEntry?: string;
}

// TODO(JJ):
// - completion
// - title separate component
// - overview block needed?

function Block(t0) {
  const $ = _c(54);
  const {
    block,
    timeUnit,
    unitTitle,
    courseId,
    moduleId,
    unitId,
    unitIndex,
    nextUrl,
    prevUrl,
    continueDisabled,
    repositoryEntry
  } = t0;
  const t = useTranslations();
  const params = useParams();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  bb0: {
    if (!pathname) {
      t1 = undefined;
      break bb0;
    }
    let t2;
    if ($[0] !== searchParams) {
      t2 = searchParams?.toString();
      $[0] = searchParams;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    const qs = t2;
    t1 = qs ? `${pathname}?${qs}` : pathname;
  }
  const openInNewTabUrl = t1;
  let t2;
  if ($[2] !== courseId || $[3] !== moduleId || $[4] !== unitId) {
    t2 = {
      courseId,
      moduleId,
      unitId
    };
    $[2] = courseId;
    $[3] = moduleId;
    $[4] = unitId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data
  } = useCachedUnitProgressSWR(t2);
  const time = data?.time || 0;
  let title = block.title;
  if (block.blockType === "pdf") {
    let t3;
    if ($[6] !== block.readingEnd || $[7] !== block.readingStart || $[8] !== block.title || $[9] !== t) {
      t3 = block.readingStart && block.readingEnd ? t("unit.pdfBlockTitle", {
        title: block.title,
        start: block.readingStart,
        end: block.readingEnd
      }) : block.title;
      $[6] = block.readingEnd;
      $[7] = block.readingStart;
      $[8] = block.title;
      $[9] = t;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    title = t3;
  }
  let t3;
  if ($[11] !== block.blockType || $[12] !== block.identifier || $[13] !== block.tag || $[14] !== block.time || $[15] !== courseId || $[16] !== moduleId || $[17] !== time || $[18] !== timeUnit || $[19] !== title || $[20] !== unitId || $[21] !== unitIndex || $[22] !== unitTitle) {
    t3 = unitTitle && <div className="mb-2 sm:mb-3"><div className="flex flex-row items-center justify-between gap-2"><div className="flex items-center gap-1.5 min-w-0 flex-1"><span className="text-primary uppercase text-xs sm:text-sm font-semibold whitespace-nowrap">UNIT {moduleId}.{unitIndex !== undefined ? unitIndex + 1 : unitId}</span><span className="text-gray-400">|</span><span className="text-primary text-xs sm:text-sm font-normal truncate">{title}</span>{block.blockType !== "olat-link" && <BlockTag tag={block.tag} />}</div><div className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0"><div className="text-[10px] sm:text-sm whitespace-nowrap"><span className="text-uzh-lightgreen">{time}</span> / {timeUnit} min</div><Suspense fallback={<CompletionTagSkeleton />}><CompletionTag courseId={courseId} moduleId={moduleId} unitId={unitId} blockIdentifier={block.identifier} blockTime={block.time} /></Suspense><BookmarkAction /><Button className={{
            root: "rounded-full w-8 h-8 text-primary-100 bg-white flex-shrink-0"
          }}><FontAwesomeIcon icon={faComment} className="h-4 w-4" /></Button></div></div><div className="text-primary text-sm sm:text-lg md:text-xl font-semibold truncate">{unitTitle}</div></div>;
    $[11] = block.blockType;
    $[12] = block.identifier;
    $[13] = block.tag;
    $[14] = block.time;
    $[15] = courseId;
    $[16] = moduleId;
    $[17] = time;
    $[18] = timeUnit;
    $[19] = title;
    $[20] = unitId;
    $[21] = unitIndex;
    $[22] = unitTitle;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[24] !== block.blockType || $[25] !== block.identifier || $[26] !== block.tag || $[27] !== block.time || $[28] !== courseId || $[29] !== moduleId || $[30] !== title || $[31] !== unitId || $[32] !== unitTitle) {
    t4 = !unitTitle && <div className="flex flex-row items-center justify-between gap-2 mb-2 sm:mb-3"><div className="flex flex-row items-center gap-1.5 sm:gap-2 md:gap-4 flex-1 min-w-0"><div className="text-primary text-xs sm:text-base md:text-lg font-semibold truncate">{title}</div>{block.blockType !== "olat-link" && <BlockTag tag={block.tag} />}</div><div className="flex-shrink-0"><Suspense fallback={<CompletionTagSkeleton />}><CompletionTag courseId={courseId} moduleId={moduleId} unitId={unitId} blockIdentifier={block.identifier} blockTime={block.time} /></Suspense></div></div>;
    $[24] = block.blockType;
    $[25] = block.identifier;
    $[26] = block.tag;
    $[27] = block.time;
    $[28] = courseId;
    $[29] = moduleId;
    $[30] = title;
    $[31] = unitId;
    $[32] = unitTitle;
    $[33] = t4;
  } else {
    t4 = $[33];
  }
  let t5;
  if ($[34] !== block || $[35] !== params.locale || $[36] !== repositoryEntry) {
    t5 = <div className="w-full max-w-full overflow-hidden"><BlockContent block={block} repositoryEntry={repositoryEntry} locale={params.locale} /></div>;
    $[34] = block;
    $[35] = params.locale;
    $[36] = repositoryEntry;
    $[37] = t5;
  } else {
    t5 = $[37];
  }
  let t6;
  if ($[38] !== t3 || $[39] !== t4 || $[40] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[38] = t3;
    $[39] = t4;
    $[40] = t5;
    $[41] = t6;
  } else {
    t6 = $[41];
  }
  const content = t6;
  if (!nextUrl) {
    let t7;
    if ($[42] !== content) {
      t7 = <div className="w-full max-w-full overflow-x-hidden">{content}</div>;
      $[42] = content;
      $[43] = t7;
    } else {
      t7 = $[43];
    }
    return t7;
  }
  let t7;
  if ($[44] !== content) {
    t7 = <div className="overflow-x-hidden flex-1">{content}</div>;
    $[44] = content;
    $[45] = t7;
  } else {
    t7 = $[45];
  }
  let t8;
  if ($[46] !== continueDisabled || $[47] !== nextUrl || $[48] !== openInNewTabUrl || $[49] !== prevUrl) {
    t8 = <StickyNavBar prevUrl={prevUrl} nextUrl={nextUrl} continueDisabled={continueDisabled} openInNewTabUrl={openInNewTabUrl} />;
    $[46] = continueDisabled;
    $[47] = nextUrl;
    $[48] = openInNewTabUrl;
    $[49] = prevUrl;
    $[50] = t8;
  } else {
    t8 = $[50];
  }
  let t9;
  if ($[51] !== t7 || $[52] !== t8) {
    t9 = <div className="w-full max-w-full min-h-[calc(100dvh-5rem)] flex flex-col">{t7}{t8}</div>;
    $[51] = t7;
    $[52] = t8;
    $[53] = t9;
  } else {
    t9 = $[53];
  }
  return t9;
}
export default Block;